import { z } from 'zod';
import { BaseFacilityDTOSchema, } from "./facilities.dto.js";
// Request and response schemas for the API layer
export const FindFacilityByIdRequestDTOSchema = z.object({
    params: z.object({
        companyId: BaseFacilityDTOSchema.shape.companyId,
        facilityId: BaseFacilityDTOSchema.shape.id,
    }),
});
//# sourceMappingURL=find-facility-by-id.dto.js.map